<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的电子证书</p>
        </div>
        <div class="menu">
            <center-menu active="6" />
        </div>
        <div class="content">
			<div class="title clearfix">
				<span class="lefts"></span><p>我的电子证书<span class="my-exam">&nbsp;&nbsp;/&nbsp;&nbsp;Details of Electronic Certificate</span></p>
			</div>
			<div class="myce clearfix" >
				<div class="myce-detail" v-for="(item, index) in certificates" :class="{'mln':index%3==0}">
					<router-link :to="`/center/mycertificated/${item.id}`">
						<img src="../../assets/images/public/bg.jpg">
						<h2>{{ item.userName }}</h2>
					</router-link>
					<p>{{ item.examName }}证书</p>
					<router-link :to="`/center/mycertificated/${item.id}/1`">
						<el-button>下载</el-button>
					</router-link>
				</div>
				<p style="text-align: center;" v-if="!certificates.length">暂无数据</p>
			</div>
        </div>
    </div>
</template>

<script>
import { enrollCertListPage } from '@/api/center'
export default {
    name: 'certificate',
    components: {
    },
    data(){
        return {
			certificates:[]
        }
    },
    mounted(){
        this.$emit('changeIndex',1)
		enrollCertListPage({userId:this.$store.getters.userInfo.id,isPre:0}).then(res => {
			if(res){
				this.certificates = res
			}
		})
    },
    methods:{
			
    }
}
</script>

<style scoped>
    .menu{float: left;width: 170px;}
    .content{float: right;width: 1028px;}
	.lefts {width: 5px;height: 24px;background:#a52821;float: left;}
	.title p {float: left; color:#a52821;font-size: 18px;line-height: 24px;margin-left: 10px;font-weight: 600;}
	.title .my-exam {font-size: 14px; color: #999999;font-weight: normal;}
	.myce-detail {margin-left: 20px; width: 32%;margin-top: 20px; box-sizing: border-box;padding: 20px;height: 305px;float: left;border: 1px solid #cccccc;position: relative;}
	.myce-detail h2{position: absolute;left: 0;top: 0;text-align: center;font-size: 18px;font-weight: 600;width: 100%;margin-top: 105px;}
	.myce-detail img {width: 288px;height: 200px;cursor: pointer;}
	.myce-detail p {font-weight: bold;margin-bottom: 5px;}
	.myce .mln {margin-left: 0;}
</style>
